import { makeStyles } from '@material-ui/core/styles'

export const myDiningStyles = makeStyles((theme) => ({
  tabBox: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
}))

export const iconTileStyle = makeStyles({
  card: {
    width: 85,
    height: 85,
  },
  gridContainer: {
    padding: 2,
  },
  tileIcon: {
    paddingTop: 12,
  },
  text: {
    fontSize: 11,
    fontWeight: 600,
    paddingTop: 4,
  },
})
